import * as React from "react";
import { Link } from "@netless/i18n-react-router";
import { FormattedMessage } from "react-intl";
import netless_logo from "../assets/image/netless_black.svg";
import "./LandingNavigation.less";
import { Button } from "antd";

export default class LandingNavigation extends React.Component<{}, {}> {

    public render(): React.ReactNode {
        return (
            <div className="nav-landing-box">
                <div className="nav-mid-box">
                    <div className="nav-left-part">
                        <div className="nav-left-logo-box">
                            <Link to="/">
                                <img src={netless_logo}  alt="netless_logo"/>
                            </Link>
                            <div className="nav-left-logo-text">
                                | <Link to="/"><FormattedMessage
                                    id="landing-nav.title"
                                /></Link>
                            </div>
                        </div>
                    </div>
                    <div className="nav-right-part">
                        <a target="_blank" href="https://developer.herewhite.com/">
                            <div className="nav-right-cell">
                                <span className="nav-right-cell-inner">
                                    <FormattedMessage
                                        id="landing-nav.document"
                                    />
                                </span>
                            </div>
                        </a>
                        <a target="_blank" href="https://www.herewhite.com/">
                            <Button
                                type="primary"
                            >
                                <FormattedMessage
                                    id="landing-nav.landing-page"
                                />
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LandingNavigation.tsx